import { create } from "zustand";
import { Instructor } from "../models/instructor";
import { Hub } from "../models/hub";
import { BankAccount } from "../models/account";

interface DomainState {
  instructor: Instructor | null;
  hub: Hub | null;
  bank_account: BankAccount | null;
  setInstructor: (instructor: Instructor) => void;
  setHub: (hub: Hub) => void;
  setBankAccount: (bank_account: BankAccount) => void;
}

export const useDomainStore = create<DomainState>((set, get) => ({
  instructor: null,
  hub: null,
  bank_account: null,

  setInstructor: (instructor) => set({ instructor }),
  setHub: (hub) => set({ hub }),
  setBankAccount: (bank_account) => set({ bank_account }),
}));
